import { Component, OnInit } from '@angular/core';
declare let $: any;

@Component({
  selector: 'app-vaccin-req-form',
  templateUrl: './vaccin-req-form.component.html',
  styleUrls: ['./vaccin-req-form.component.scss']
})
export class VaccinReqFormComponent implements OnInit {

  submit=false;

  constructor() { }

  ngOnInit(): void {
  }
  
  openModal(id): void {
    $(id).modal({ backdrop: 'static', keyboard: false });
    console.log("open model");
  }

  closeModal(): void {
    this.submit = false;
  }

}
